<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'

  import Promo2019Pact from './Promo2019_Pact.vue'
  import Promo2019Events from './Promo2019_Events.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsPromo2019Events = Promo2019Events.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019Pact = Promo2019Pact.data().items


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-12-02',
        major: [
          'さらコレクション',
          'アンジュコレクション',
          '共通',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] JR6
          // ================================================================================

          item({
            collection  : 'さらコレクション',
            id          : 'JR6-04',
            rare        : 'JR',
            name        : 'じょうねつのピンクジュエルドレス',
            imgUrl      : '/images/items/JR6-04.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-05',
            rare        : 'JR',
            name        : 'じょうねつのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR6-05.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-06',
            rare        : 'JR',
            name        : 'じょうねつのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR6-06.png',
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-07',
            rare        : 'JR',
            name        : 'じょうねつのイエロージュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR6-07',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-08',
            rare        : 'JR',
            name        : 'じょうねつのイエロージュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR6-08',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-09',
            rare        : 'JR',
            name        : 'じょうねつのイエロージュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR6-09',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-10',
            rare        : 'JR',
            name        : 'じょうねつのブルージュエルドレス',
            imgUrl      : '/images/items/JR6-10.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-11',
            rare        : 'JR',
            name        : 'じょうねつのブルージュエルシューズ',
            imgUrl      : '/images/items/JR6-11.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-12',
            rare        : 'JR',
            name        : 'じょうねつのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR6-12.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-13',
            rare        : 'JR',
            name        : 'じょうねつのゴールドジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/ffcc66/666/?text=JR6-13',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-14',
            rare        : 'JR',
            name        : 'じょうねつのゴールドジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/ffcc66/666/?text=JR6-14',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-15',
            rare        : 'JR',
            name        : 'じょうねつのゴールドジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/ffcc66/666/?text=JR6-15',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-16',
            rare        : 'JR',
            name        : 'じょうねつのブラックジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR6-16',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-17',
            rare        : 'JR',
            name        : 'じょうねつのブラックジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR6-17',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-18',
            rare        : 'JR',
            name        : 'じょうねつのブラックジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR6-18',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-19',
            rare        : 'JR',
            name        : 'じょうねつのレッドジュエルドレス',
            imgUrl      : '/images/items/JR6-19.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-20',
            rare        : 'JR',
            name        : 'じょうねつのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR6-20.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-21',
            rare        : 'JR',
            name        : 'じょうねつのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR6-21.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-01',
            rare        : 'JR',
            name        : 'じょうねつのグリーンジュエルドレス',
            imgUrl      : '/images/items/JR6-01.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-02',
            rare        : 'JR',
            name        : 'じょうねつのグリーンジュエルシューズ',
            imgUrl      : '/images/items/JR6-02.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-03',
            rare        : 'JR',
            name        : 'じょうねつのグリーンジュエルヘアアクセ',
            imgUrl      : '/images/items/JR6-03.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-22',
            rare        : 'JR',
            name        : 'じょうねつのパープルジュエルドレス',
            imgUrl      : '/images/items/JR6-22.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-23',
            rare        : 'JR',
            name        : 'じょうねつのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR6-23.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-24',
            rare        : 'JR',
            name        : 'じょうねつのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR6-24.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-25',
            rare        : 'JR',
            name        : 'じょうねつのホワイトジュエルドレス',
            imgUrl      : '/images/items/JR6-25.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-26',
            rare        : 'JR',
            name        : 'じょうねつのホワイトジュエルシューズ',
            imgUrl      : '/images/items/JR6-26.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-27',
            rare        : 'JR',
            name        : 'じょうねつのホワイトジュエルヘアアクセ',
            imgUrl      : '/images/items/JR6-27.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'JR6-28',
            rare        : 'JR',
            name        : 'じょうねつのレインボージュエルドレス',
            imgUrl      : '/images/items/JR6-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'RB',
            type        : 'CO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-29',
            rare        : 'JR',
            name        : 'じょうねつのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR6-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'JR6-30',
            rare        : 'JR',
            name        : 'じょうねつのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR6-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'JR',
          }),


          // [NOTE] JR7
          // ================================================================================

          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-04',
            rare        : 'JR',
            name        : 'きぼうのピンクジュエルドレス',
            imgUrl      : '/images/items/JR7-04.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-05',
            rare        : 'JR',
            name        : 'きぼうのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR7-05.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-06',
            rare        : 'JR',
            name        : 'きぼうのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR7-06.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-07',
            rare        : 'JR',
            name        : 'きぼうのイエロージュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR7-07',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-08',
            rare        : 'JR',
            name        : 'きぼうのイエロージュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR7-08',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-09',
            rare        : 'JR',
            name        : 'きぼうのイエロージュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR7-09',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-10',
            rare        : 'JR',
            name        : 'きぼうのブルージュエルドレス',
            imgUrl      : '/images/items/JR7-10.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-11',
            rare        : 'JR',
            name        : 'きぼうのブルージュエルシューズ',
            imgUrl      : '/images/items/JR7-11.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-12',
            rare        : 'JR',
            name        : 'きぼうのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR7-12.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-13',
            rare        : 'JR',
            name        : 'きぼうのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR7-13.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-14',
            rare        : 'JR',
            name        : 'きぼうのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR7-14.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-15',
            rare        : 'JR',
            name        : 'きぼうのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR7-15.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-16',
            rare        : 'JR',
            name        : 'きぼうのブラックジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR7-16',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-17',
            rare        : 'JR',
            name        : 'きぼうのブラックジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR7-17',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-18',
            rare        : 'JR',
            name        : 'きぼうのブラックジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR7-18',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-19',
            rare        : 'JR',
            name        : 'きぼうのレッドジュエルドレス',
            imgUrl      : '/images/items/JR7-19.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-20',
            rare        : 'JR',
            name        : 'きぼうのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR7-20.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-21',
            rare        : 'JR',
            name        : 'きぼうのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR7-21.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-22',
            rare        : 'JR',
            name        : 'きぼうのグリーンジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR7-22',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-23',
            rare        : 'JR',
            name        : 'きぼうのグリーンジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR7-23',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-24',
            rare        : 'JR',
            name        : 'きぼうのグリーンジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR7-24',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-25',
            rare        : 'JR',
            name        : 'きぼうのパープルジュエルドレス',
            imgUrl      : '/images/items/JR7-25.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-26',
            rare        : 'JR',
            name        : 'きぼうのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR7-26.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-27',
            rare        : 'JR',
            name        : 'きぼうのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR7-27.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-01',
            rare        : 'JR',
            name        : 'きぼうのホワイトジュエルドレス',
            imgUrl      : '/images/items/JR7-01.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-02',
            rare        : 'JR',
            name        : 'きぼうのホワイトジュエルシューズ',
            imgUrl      : '/images/items/JR7-02.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-03',
            rare        : 'JR',
            name        : 'きぼうのホワイトジュエルヘアアクセ',
            imgUrl      : '/images/items/JR7-03.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-28',
            rare        : 'JR',
            name        : 'きぼうのレインボージュエルドレス',
            imgUrl      : '/images/items/JR7-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-29',
            rare        : 'JR',
            name        : 'きぼうのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR7-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'JR7-30',
            rare        : 'JR',
            name        : 'きぼうのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR7-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'JR',
          }),


          // [NOTE] RR
          // ================================================================================

          item({
            collection  : 'さらコレクション',
            id          : 'RR4-01',
            rare        : 'RR',
            name        : 'レインボーかぐやひめワンピ',
            imgUrl      : '/images/items/RR4-01.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'RR4-02',
            rare        : 'RR',
            name        : 'レインボーかぐやひめシューズ',
            imgUrl      : '/images/items/RR4-02.png',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'RR4-03',
            rare        : 'RR',
            name        : 'レインボーかぐやひめヘアアクセ',
            imgUrl      : '/images/items/RR4-03.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'RR4-04',
            rare        : 'RR',
            name        : 'レインボーシークレットアリスワンピ',
            imgUrl      : '/images/items/RR4-04.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'RR4-05',
            rare        : 'RR',
            name        : 'レインボーシークレットアリスシューズ',
            imgUrl      : '/images/items/RR4-05.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'RR4-06',
            rare        : 'RR',
            name        : 'レインボーシークレットアリスヘアアクセ',
            imgUrl      : '/images/items/RR4-06.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'RR4-07',
            rare        : 'RR',
            name        : 'レインボーロマンスビートワンピ',
            imgUrl      : '/images/items/RR4-07.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'RR4-08',
            rare        : 'RR',
            name        : 'レインボーロマンスビートシューズ',
            imgUrl      : '/images/items/RR4-08.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'RR4-09',
            rare        : 'RR',
            name        : 'レインボーロマンスビートヘアアクセ',
            imgUrl      : '/images/items/RR4-09.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-10',
            rare        : 'RR',
            name        : 'レインボーおとのさまワンピ',
            imgUrl      : '/images/items/RR4-10.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-11',
            rare        : 'RR',
            name        : 'レインボーおとのさまシューズ',
            imgUrl      : '/images/items/RR4-11.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-12',
            rare        : 'RR',
            name        : 'レインボーおとのさまヘアアクセ',
            imgUrl      : '/images/items/RR4-12.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-13',
            rare        : 'RR',
            name        : 'レインボードーリーワルツワンピ',
            imgUrl      : '/images/items/RR4-13.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-14',
            rare        : 'RR',
            name        : 'レインボードーリーワルツシューズ',
            imgUrl      : '/images/items/RR4-14.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-15',
            rare        : 'RR',
            name        : 'レインボードーリーワルツヘアアクセ',
            imgUrl      : '/images/items/RR4-15.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-16',
            rare        : 'RR',
            name        : 'レインボーユニバースクイーンワンピ',
            imgUrl      : '/images/items/RR4-16.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-17',
            rare        : 'RR',
            name        : 'レインボーユニバースクイーンシューズ',
            imgUrl      : '/images/items/RR4-17.png',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'RR4-18',
            rare        : 'RR',
            name        : 'レインボーユニバースクイーンヘアアクセ',
            imgUrl      : '/images/items/RR4-18.png',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'RR',
          }),


          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'さらコレクション',
            id          : 'J4-01',
            rare        : 'HR',
            name        : 'かぐやひめワンピ',
            imgUrl      : '/images/items/J4-01.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-02',
            rare        : 'HR',
            name        : 'かぐやひめシューズ',
            imgUrl      : '/images/items/J4-02.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-03',
            rare        : 'HR',
            name        : 'かぐやひめヘアアクセ',
            imgUrl      : '/images/items/J4-03.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'J4-04',
            rare        : 'HR',
            name        : 'おとのさまワンピ',
            imgUrl      : '/images/items/J4-04.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-05',
            rare        : 'HR',
            name        : 'おとのさまシューズ',
            imgUrl      : '/images/items/J4-05.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-06',
            rare        : 'HR',
            name        : 'おとのさまヘアアクセ',
            imgUrl      : '/images/items/J4-06.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'J4-07',
            rare        : 'HR',
            name        : 'ホロスコープてんびんざワンピ',
            imgUrl      : '/images/items/J4-07.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-08',
            rare        : 'HR',
            name        : 'ホロスコープてんびんざシューズ',
            imgUrl      : '/images/items/J4-08.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-09',
            rare        : 'HR',
            name        : 'ホロスコープてんびんざヘアアクセ',
            imgUrl      : '/images/items/J4-09.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'J4-10',
            rare        : 'HR',
            name        : 'ホロスコープおとめざワンピ',
            imgUrl      : '/images/items/J4-10.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-11',
            rare        : 'HR',
            name        : 'ホロスコープおとめざシューズ',
            imgUrl      : '/images/items/J4-11.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-12',
            rare        : 'HR',
            name        : 'ホロスコープおとめざヘアアクセ',
            imgUrl      : '/images/items/J4-12.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-82',
            rare        : 'HR',
            name        : 'かぐやひめわかばワンピ',
            imgUrl      : '/images/items/J4-82.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-83',
            rare        : 'HR',
            name        : 'かぐやひめわかばシューズ',
            imgUrl      : '/images/items/J4-83.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-84',
            rare        : 'HR',
            name        : 'かぐやひめわかばヘアアクセ',
            imgUrl      : '/images/items/J4-84.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-85',
            rare        : 'HR',
            name        : 'おとのさまくれないワンピ',
            imgUrl      : '/images/items/J4-85.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-86',
            rare        : 'HR',
            name        : 'おとのさまくれないシューズ',
            imgUrl      : '/images/items/J4-86.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-87',
            rare        : 'HR',
            name        : 'おとのさまくれないヘアアクセ',
            imgUrl      : '/images/items/J4-87.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'HR',
          }),


          externalItem(itemsPromo2019Events, 'P-122', { collection: 'アンジュコレクション' }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'P-123',
            rare        : 'HR',
            name        : 'おとのさまもえぎシューズ',
            imgUrl      : '/images/items/P-123.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          externalItem(itemsPromo2019Events, 'P-124', { collection: 'アンジュコレクション' }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-88',
            rare        : 'HR',
            name        : 'ホロスコープさそりざワンピ',
            imgUrl      : '/images/items/J4-88.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-89',
            rare        : 'HR',
            name        : 'ホロスコープさそりざシューズ',
            imgUrl      : '/images/items/J4-89.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-90',
            rare        : 'HR',
            name        : 'ホロスコープさそりざヘアアクセ',
            imgUrl      : '/images/items/J4-90.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-91',
            rare        : 'HR',
            name        : 'ホロスコープおひつじざワンピ',
            imgUrl      : '/images/items/J4-91.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-92',
            rare        : 'HR',
            name        : 'ホロスコープおひつじざシューズ',
            imgUrl      : '/images/items/J4-92.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-93',
            rare        : 'HR',
            name        : 'ホロスコープおひつじざヘアアクセ',
            imgUrl      : '/images/items/J4-93.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'さらコレクション',
            id          : 'J4-13',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアブルートップス',
            imgUrl      : '/images/items/J4-13.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-14',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアブルーパンツ',
            imgUrl      : '/images/items/J4-14.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-15',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアブルーシューズ',
            imgUrl      : '/images/items/J4-15.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-16',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアブルーヘアアクセ',
            imgUrl      : '/images/items/J4-16.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'J4-17',
            rare        : 'PR',
            name        : 'フルスイングスタートップス',
            imgUrl      : '/images/items/J4-17.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-18',
            rare        : 'PR',
            name        : 'フルスイングスターパンツ',
            imgUrl      : '/images/items/J4-18.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-19',
            rare        : 'PR',
            name        : 'フルスイングスターシューズ',
            imgUrl      : '/images/items/J4-19.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-20',
            rare        : 'PR',
            name        : 'フルスイングスターヘアアクセ',
            imgUrl      : '/images/items/J4-20.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'J4-21',
            rare        : 'PR',
            name        : 'フルスイングスターイエロートップス',
            imgUrl      : '/images/items/J4-21.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-22',
            rare        : 'PR',
            name        : 'フルスイングスターイエローパンツ',
            imgUrl      : '/images/items/J4-22.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-23',
            rare        : 'PR',
            name        : 'フルスイングスターイエローシューズ',
            imgUrl      : '/images/items/J4-23.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-24',
            rare        : 'PR',
            name        : 'フルスイングスターイエローヘアアクセ',
            imgUrl      : '/images/items/J4-24.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-94',
            rare        : 'PR',
            name        : 'フェニックスフレアトップス',
            imgUrl      : '/images/items/J4-94.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-95',
            rare        : 'PR',
            name        : 'フェニックスフレアスカート',
            imgUrl      : '/images/items/J4-95.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-96',
            rare        : 'PR',
            name        : 'フェニックスフレアシューズ',
            imgUrl      : '/images/items/J4-96.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-97',
            rare        : 'PR',
            name        : 'フェニックスフレアヘアアクセ',
            imgUrl      : '/images/items/J4-97.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-98',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアオレンジトップス',
            imgUrl      : '/images/items/J4-98.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-99',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアオレンジスカート',
            imgUrl      : '/images/items/J4-99.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-100',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアオレンジシューズ',
            imgUrl      : '/images/items/J4-100.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-101',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアオレンジヘアアクセ',
            imgUrl      : '/images/items/J4-101.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-102',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアピンクトップス',
            imgUrl      : '/images/items/J4-102.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-103',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアピンクスカート',
            imgUrl      : '/images/items/J4-103.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-104',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアピンクシューズ',
            imgUrl      : '/images/items/J4-104.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-105',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアピンクヘアアクセ',
            imgUrl      : '/images/items/J4-105.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR モーリーファンタジー限定
          // ================================================================================

          externalItem(itemsPromo2019Events, 'MF-29', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-30', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-31', { collection: 'モーリーファンタジー限定' }),
          item({
            collection  : 'モーリーファンタジー限定',
            rare        : 'SR',
          }),


          externalItem(itemsPromo2019Events, 'MF-36', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-37', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-38', { collection: 'モーリーファンタジー限定' }),
          item({
            collection  : 'モーリーファンタジー限定',
            rare        : 'SR',
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          externalItem(itemsPromo2019Events, 'MF-32', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-33', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-34', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-35', { collection: 'モーリーファンタジー限定' }),


          externalItem(itemsPromo2019Events, 'MF-39', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-40', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-41', { collection: 'モーリーファンタジー限定' }),
          externalItem(itemsPromo2019Events, 'MF-42', { collection: 'モーリーファンタジー限定' }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'さらコレクション',
            id          : 'J4-25',
            rare        : 'SR',
            name        : 'ハロウィンナイトトップス',
            imgUrl      : '/images/items/J4-25.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-26',
            rare        : 'SR',
            name        : 'ハロウィンナイトスカート',
            imgUrl      : '/images/items/J4-26.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-27',
            rare        : 'SR',
            name        : 'ハロウィンナイトシューズ',
            imgUrl      : '/images/items/J4-27.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-28',
            rare        : 'SR',
            name        : 'ハロウィンナイトヘアアクセ',
            imgUrl      : '/images/items/J4-28.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'J4-29',
            rare        : 'SR',
            name        : 'ロマーノアーティストトップス',
            imgUrl      : '/images/items/J4-29.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-30',
            rare        : 'SR',
            name        : 'ロマーノアーティストスカート',
            imgUrl      : '/images/items/J4-30.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-31',
            rare        : 'SR',
            name        : 'ロマーノアーティストシューズ',
            imgUrl      : '/images/items/J4-31.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-32',
            rare        : 'SR',
            name        : 'ロマーノアーティストヘアアクセ',
            imgUrl      : '/images/items/J4-32.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'さらコレクション',
            id          : 'J4-33',
            rare        : 'SR',
            name        : 'ティーパーティーハーブトップス',
            imgUrl      : '/images/items/J4-33.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-34',
            rare        : 'SR',
            name        : 'ティーパーティーハーブスカート',
            imgUrl      : '/images/items/J4-34.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-35',
            rare        : 'SR',
            name        : 'ティーパーティーハーブシューズ',
            imgUrl      : '/images/items/J4-35.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-36',
            rare        : 'SR',
            name        : 'ティーパーティーハーブヘアアクセ',
            imgUrl      : '/images/items/J4-36.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-106',
            rare        : 'SR',
            name        : 'ハロウィンナイトグリーントップス',
            imgUrl      : '/images/items/J4-106.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-107',
            rare        : 'SR',
            name        : 'ハロウィンナイトグリーンスカート',
            imgUrl      : '/images/items/J4-107.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-108',
            rare        : 'SR',
            name        : 'ハロウィンナイトグリーンシューズ',
            imgUrl      : '/images/items/J4-108.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-109',
            rare        : 'SR',
            name        : 'ハロウィンナイトグリーンヘアアクセ',
            imgUrl      : '/images/items/J4-109.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-110',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴトップス',
            imgUrl      : '/images/items/J4-110.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-111',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴスカート',
            imgUrl      : '/images/items/J4-111.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-112',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴシューズ',
            imgUrl      : '/images/items/J4-112.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-113',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴヘアアクセ',
            imgUrl      : '/images/items/J4-113.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-114',
            rare        : 'SR',
            name        : 'ティーパーティーストロベリートップス',
            imgUrl      : '/images/items/J4-114.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-115',
            rare        : 'SR',
            name        : 'ティーパーティーストロベリースカート',
            imgUrl      : '/images/items/J4-115.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-116',
            rare        : 'SR',
            name        : 'ティーパーティーストロベリーシューズ',
            imgUrl      : '/images/items/J4-116.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-117',
            rare        : 'SR',
            name        : 'ティーパーティーストロベリーヘアアクセ',
            imgUrl      : '/images/items/J4-117.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J4-39',
            rare        : 'R',
            name        : 'カラフルパレードトップス',
            imgUrl      : '/images/items/J4-39.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-40',
            rare        : 'R',
            name        : 'カラフルパレードスカート',
            imgUrl      : '/images/items/J4-40.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-41',
            rare        : 'R',
            name        : 'カラフルパレードシューズ',
            imgUrl      : '/images/items/J4-41.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-42',
            rare        : 'R',
            name        : 'カラフルパレードヘアアクセ',
            imgUrl      : '/images/items/J4-42.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J4-43',
            rare        : 'R',
            name        : 'グレイスレースミントトップス',
            imgUrl      : '/images/items/J4-43.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-44',
            rare        : 'R',
            name        : 'グレイスレースミントスカート',
            imgUrl      : '/images/items/J4-44.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-45',
            rare        : 'R',
            name        : 'グレイスレースミントシューズ',
            imgUrl      : '/images/items/J4-45.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-46',
            rare        : 'R',
            name        : 'グレイスレースミントヘアアクセ',
            imgUrl      : '/images/items/J4-46.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J4-47',
            rare        : 'R',
            name        : 'ラブリーニットホワイトコルセットトップス',
            imgUrl      : '/images/items/J4-47.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({

            collection  : '共通',
            id          : 'J4-48',
            rare        : 'R',
            name        : 'ラブリーニットホワイトスカート',
            imgUrl      : '/images/items/J4-48.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-49',
            rare        : 'R',
            name        : 'ラブリーニットホワイトシューズ',
            imgUrl      : '/images/items/J4-49.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-50',
            rare        : 'R',
            name        : 'ラブリーニットホワイトヘアアクセ',
            imgUrl      : '/images/items/J4-50.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J4-51',
            rare        : 'R',
            name        : 'ストライプビッグシルエットパーカ',
            imgUrl      : '/images/items/J4-51.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-52',
            rare        : 'R',
            name        : 'ストライプスニーカー',
            imgUrl      : '/images/items/J4-52.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-53',
            rare        : 'R',
            name        : 'ストライプサンバイザーヘアアクセ',
            imgUrl      : '/images/items/J4-53.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J4-54',
            rare        : 'N',
            name        : 'ティーカップメルヘンリメイクパープルトップス',
            imgUrl      : '/images/items/J4-54.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-55',
            rare        : 'N',
            name        : 'ティーカップメルヘンリメイクパープルスカート',
            imgUrl      : '/images/items/J4-55.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-56',
            rare        : 'N',
            name        : 'ティーカップメルヘンリメイクパープルシューズ',
            imgUrl      : '/images/items/J4-56.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-57',
            rare        : 'N',
            name        : 'ティーカップメルヘンリメイクパープルヘアアクセ',
            imgUrl      : '/images/items/J4-57.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J4-58',
            rare        : 'N',
            name        : 'トランプディーラーディープグリーントップス',
            imgUrl      : '/images/items/J4-58.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-59',
            rare        : 'N',
            name        : 'トランプディーラーディープグリーンスカート',
            imgUrl      : '/images/items/J4-59.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-60',
            rare        : 'N',
            name        : 'トランプディーラーディープグリーンシューズ',
            imgUrl      : '/images/items/J4-60.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-61',
            rare        : 'N',
            name        : 'トランプディーラーディープグリーンヘアアクセ',
            imgUrl      : '/images/items/J4-61.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J4-62',
            rare        : 'N',
            name        : 'サーキットチェッカートップス',
            imgUrl      : '/images/items/J4-62.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-63',
            rare        : 'N',
            name        : 'サーキットチェッカーパンツ',
            imgUrl      : '/images/items/J4-63.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-64',
            rare        : 'N',
            name        : 'サーキットチェッカーシューズ',
            imgUrl      : '/images/items/J4-64.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J4-65',
            rare        : 'N',
            name        : 'サーキットチェッカーサングラス',
            imgUrl      : '/images/items/J4-65.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'さらコレクション',
            id          : 'J4-37',
            rare        : 'R',
            name        : 'ハロウィンナイトバッグ',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J4-37.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
          }),
          item({
            collection  : 'さらコレクション',
            id          : 'J4-38',
            rare        : 'R',
            name        : 'エメラルドティーカップ＆ソーサー',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J4-38.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-118',
            rare        : 'R',
            name        : 'ぐっすりまくら',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J4-118.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
          }),
          item({
            collection  : 'アンジュコレクション',
            id          : 'J4-119',
            rare        : 'R',
            name        : 'イエローフェザーせんす',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J4-119.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
          }),


          // [NOTE] ブランドランク
          // ================================================================================

          item({
            collection  : 'ブランドランク',
            id          : 'RB-13',
            rare        : 'R',
            name        : 'ポリスガールグリーントップス',
            imgUrl      : '/images/items/RB-13.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'RB-14',
            rare        : 'R',
            name        : 'ポリスガールグリーンパンツ',
            imgUrl      : '/images/items/RB-14.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'RB-15',
            rare        : 'R',
            name        : 'ポリスガールグリーンシューズ',
            imgUrl      : '/images/items/RB-15.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'RB-16',
            rare        : 'R',
            name        : 'ポリスガールグリーンヘアアクセ',
            imgUrl      : '/images/items/RB-16.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ブランドランク',
            id          : 'PM-09',
            rare        : 'R',
            name        : 'グレイスレースピンクトップス',
            imgUrl      : '/images/items/PM-09.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'PM-10',
            rare        : 'R',
            name        : 'グレイスレースピンクスカート',
            imgUrl      : '/images/items/PM-10.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'PM-11',
            rare        : 'R',
            name        : 'グレイスレースピンクシューズ',
            imgUrl      : '/images/items/PM-11.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'PM-12',
            rare        : 'R',
            name        : 'グレイスレースピンクヘアアクセ',
            imgUrl      : '/images/items/PM-12.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-17',
            rare        : 'SR',
            name        : 'オータムリーフマロンワンピ',
            imgUrl      : '/images/items/PB-17.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-18',
            rare        : 'SR',
            name        : 'オータムリーフマロンシューズ',
            imgUrl      : '/images/items/PB-18.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-19',
            rare        : 'SR',
            name        : 'オータムリーフヘアアクセ',
            imgUrl      : '/images/items/PB-19.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            rare        : 'SR',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-20',
            rare        : 'SR',
            name        : 'マーブルドーナツトップス',
            imgUrl      : '/images/items/PB-20.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-21',
            rare        : 'SR',
            name        : 'マーブルドーナツパンツ',
            imgUrl      : '/images/items/PB-21.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-22',
            rare        : 'SR',
            name        : 'マーブルドーナツシューズ',
            imgUrl      : '/images/items/PB-22.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-23',
            rare        : 'SR',
            name        : 'マーブルドーナツヘアアクセ',
            imgUrl      : '/images/items/PB-23.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-24',
            rare        : 'R',
            name        : 'プリパス',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/PB-24.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            kind        : 'パシャッとアイテム',
            rare        : 'R',
          }),
          item({
            collection  : 'プレゼントボックス',
            kind        : 'パシャッとアイテム',
            rare        : 'R',
          }),
          item({
            collection  : 'プレゼントボックス',
            kind        : 'パシャッとアイテム',
            rare        : 'R',
          }),


          // [NOTE] ジュエルパクト
          // ================================================================================

          externalItem(itemsPromo2019Pact, 'JP-176', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-177', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-178', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-179', { collection: 'ジュエルパクト' }),


          // [NOTE] 芸術の秋チャンネル
          // ================================================================================

          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-66',
            rare        : 'SR',
            name        : 'ロマーノアーティストターコイズトップス',
            imgUrl      : '/images/items/J4-66.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-67',
            rare        : 'SR',
            name        : 'ロマーノアーティストターコイズスカート',
            imgUrl      : '/images/items/J4-67.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-68',
            rare        : 'SR',
            name        : 'ロマーノアーティストターコイズシューズ',
            imgUrl      : '/images/items/J4-68.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-69',
            rare        : 'SR',
            name        : 'ロマーノアーティストターコイズヘアアクセ',
            imgUrl      : '/images/items/J4-69.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-70',
            rare        : 'SR',
            name        : 'ロマーノアーティストピンクトップス',
            imgUrl      : '/images/items/J4-70.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-71',
            rare        : 'SR',
            name        : 'ロマーノアーティストピンクスカート',
            imgUrl      : '/images/items/J4-71.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-72',
            rare        : 'SR',
            name        : 'ロマーノアーティストピンクシューズ',
            imgUrl      : '/images/items/J4-72.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '芸術の秋チャンネル',
            id          : 'J4-73',
            rare        : 'SR',
            name        : 'ロマーノアーティストピンクヘアアクセ',
            imgUrl      : '/images/items/J4-73.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ハロウィンナイトチャンネル
          // ================================================================================

          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-74',
            rare        : 'SR',
            name        : 'ハロウィンナイトパープルトップス',
            imgUrl      : '/images/items/J4-74.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-75',
            rare        : 'SR',
            name        : 'ハロウィンナイトパープルスカート',
            imgUrl      : '/images/items/J4-75.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-76',
            rare        : 'SR',
            name        : 'ハロウィンナイトパープルシューズ',
            imgUrl      : '/images/items/J4-76.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-77',
            rare        : 'SR',
            name        : 'ハロウィンナイトパープルヘアアクセ',
            imgUrl      : '/images/items/J4-77.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-78',
            rare        : 'SR',
            name        : 'ハロウィンナイトカラフルトップス',
            imgUrl      : '/images/items/J4-78.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-79',
            rare        : 'SR',
            name        : 'ハロウィンナイトカラフルスカート',
            imgUrl      : '/images/items/J4-79.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-80',
            rare        : 'SR',
            name        : 'ハロウィンナイトカラフルシューズ',
            imgUrl      : '/images/items/J4-80.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンナイトチャンネル',
            id          : 'J4-81',
            rare        : 'SR',
            name        : 'ハロウィンナイトカラフルヘアアクセ',
            imgUrl      : '/images/items/J4-81.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリティーオールフレンズチャンネル
          // ================================================================================

          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-01',
            rare        : 'SR',
            name        : 'プリティーオールフレンズなるトップス',
            imgUrl      : '/images/items/PAF-J4-01.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-02',
            rare        : 'SR',
            name        : 'プリティーオールフレンズなるスカート',
            imgUrl      : '/images/items/PAF-J4-02.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-03',
            rare        : 'SR',
            name        : 'プリティーオールフレンズなるシューズ',
            imgUrl      : '/images/items/PAF-J4-03.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-04',
            rare        : 'SR',
            name        : 'プリティーオールフレンズハッピーレイン♪ヘアアクセ',
            imgUrl      : '/images/items/PAF-J4-04.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-05',
            rare        : 'SR',
            name        : 'プリティーオールフレンズあんトップス',
            imgUrl      : '/images/items/PAF-J4-05.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-06',
            rare        : 'SR',
            name        : 'プリティーオールフレンズあんパンツ',
            imgUrl      : '/images/items/PAF-J4-06.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-07',
            rare        : 'SR',
            name        : 'プリティーオールフレンズあんシューズ',
            imgUrl      : '/images/items/PAF-J4-07.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-08',
            rare        : 'SR',
            name        : 'プリティーオールフレンズいとトップス',
            imgUrl      : '/images/items/PAF-J4-08.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-09',
            rare        : 'SR',
            name        : 'プリティーオールフレンズいとパンツ',
            imgUrl      : '/images/items/PAF-J4-09.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J4-10',
            rare        : 'SR',
            name        : 'プリティーオールフレンズいとシューズ',
            imgUrl      : '/images/items/PAF-J4-10.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-01',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムシオンアナザーワンピ',
            imgUrl      : '/images/items/NC-J3-01.png',
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-02',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムシオンアナザーシューズ',
            imgUrl      : '/images/items/NC-J3-02.png',
            aggregation : 'NC-J3-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-03',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムシオンアナザーヘアアクセ',
            imgUrl      : '/images/items/NC-J3-03.png',
            aggregation : 'NC-J3-01',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'PR',
          }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-04',
            rare        : 'SR',
            name        : 'キャンディアラモードピンクサイリウムワンピ',
            imgUrl      : '/images/items/NC-J3-04.png',
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-05',
            rare        : 'SR',
            name        : 'キャンディアラモードピンクサイリウムシューズ',
            imgUrl      : '/images/items/NC-J3-05.png',
            aggregation : 'NC-J3-04',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-06',
            rare        : 'SR',
            name        : 'キャンディアラモードピンクサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-J3-06.png',
            aggregation : 'NC-J3-04',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-07',
            rare        : 'SR',
            name        : 'フォーチュンパーティーグリーンサイリウムワンピ',
            imgUrl      : '/images/items/NC-J3-07.png',
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-08',
            rare        : 'SR',
            name        : 'フォーチュンパーティーグリーンサイリウムシューズ',
            imgUrl      : '/images/items/NC-J3-08.png',
            aggregation : 'NC-J3-07',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-09',
            rare        : 'SR',
            name        : 'フォーチュンパーティーグリーンサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-J3-09.png',
            aggregation : 'NC-J3-07',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-10',
            rare        : 'R',
            name        : 'チェリーチェリーワンピ',
            imgUrl      : '/images/items/NC-J3-10.png',
            numOwned    : { nico: 6 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-11',
            rare        : 'R',
            name        : 'チェリーチェリーシューズ',
            imgUrl      : '/images/items/NC-J3-11.png',
            aggregation : 'NC-J3-10',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-12',
            rare        : 'R',
            name        : 'チェリーチェリーヘアアクセ',
            imgUrl      : '/images/items/NC-J3-12.png',
            aggregation : 'NC-J3-10',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-13',
            rare        : 'R',
            name        : 'チェリーチェリーウェルカムワンピ',
            imgUrl      : '/images/items/NC-J3-13.png',
            numOwned    : { nico: 6 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-14',
            rare        : 'R',
            name        : 'チェリーチェリーウェルカムシューズ',
            imgUrl      : '/images/items/NC-J3-14.png',
            aggregation : 'NC-J3-13',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-15',
            rare        : 'R',
            name        : 'チェリーチェリーウェルカムヘアアクセ',
            imgUrl      : '/images/items/NC-J3-15.png',
            aggregation : 'NC-J3-13',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-16',
            rare        : 'R',
            name        : 'チェリーチェリーレディートップス',
            imgUrl      : '/images/items/NC-J3-16.png',
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-17',
            rare        : 'R',
            name        : 'チェリーチェリーレディースカート',
            imgUrl      : '/images/items/NC-J3-17.png',
            aggregation : 'NC-J3-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-18',
            rare        : 'R',
            name        : 'チェリーチェリーレディーシューズ',
            imgUrl      : '/images/items/NC-J3-18.png',
            aggregation : 'NC-J3-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-19',
            rare        : 'R',
            name        : 'チェリーチェリーレディーヘアアクセ',
            imgUrl      : '/images/items/NC-J3-19.png',
            aggregation : 'NC-J3-16',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-20',
            rare        : 'R',
            name        : 'ガァルマゲドンピンクハートトップス',
            imgUrl      : '/images/items/NC-J3-20.png',
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-21',
            rare        : 'R',
            name        : 'ガァルマゲドンピンクハートスカート',
            imgUrl      : '/images/items/NC-J3-21.png',
            aggregation : 'NC-J3-20',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-22',
            rare        : 'R',
            name        : 'ガァルマゲドンピンクハートシューズ',
            imgUrl      : '/images/items/NC-J3-22.png',
            aggregation : 'NC-J3-20',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-23',
            rare        : 'R',
            name        : 'ガァルマゲドンピンクハートヘアアクセ',
            imgUrl      : '/images/items/NC-J3-23.png',
            aggregation : 'NC-J3-20',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-24',
            rare        : 'R',
            name        : 'ワイズガールピンクハートトップス',
            imgUrl      : '/images/items/NC-J3-24.png',
            numOwned    : { nico: 5 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-25',
            rare        : 'R',
            name        : 'ワイズガールピンクハートスカート',
            imgUrl      : '/images/items/NC-J3-25.png',
            aggregation : 'NC-J3-24',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-26',
            rare        : 'R',
            name        : 'ワイズガールピンクハートシューズ',
            imgUrl      : '/images/items/NC-J3-26.png',
            aggregation : 'NC-J3-24',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-27',
            rare        : 'R',
            name        : 'ワイズガールピンクハートヘアアクセ',
            imgUrl      : '/images/items/NC-J3-27.png',
            aggregation : 'NC-J3-24',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-28',
            rare        : 'R',
            name        : 'マジカる☆スターピンクハートトップス',
            imgUrl      : '/images/items/NC-J3-28.png',
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-29',
            rare        : 'R',
            name        : 'マジカる☆スターピンクハートスカート',
            imgUrl      : '/images/items/NC-J3-29.png',
            aggregation : 'NC-J3-28',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-30',
            rare        : 'R',
            name        : 'マジカる☆スターピンクハートシューズ',
            imgUrl      : '/images/items/NC-J3-30.png',
            aggregation : 'NC-J3-28',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-31',
            rare        : 'R',
            name        : 'マジカる☆スターピンクハートヘアアクセ',
            imgUrl      : '/images/items/NC-J3-31.png',
            aggregation : 'NC-J3-28',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-32',
            rare        : 'R',
            name        : 'マジカる☆スターブルークラブトップス',
            imgUrl      : '/images/items/NC-J3-32.png',
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-33',
            rare        : 'R',
            name        : 'マジカる☆スターブルークラブスカート',
            imgUrl      : '/images/items/NC-J3-33.png',
            aggregation : 'NC-J3-32',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-34',
            rare        : 'R',
            name        : 'マジカる☆スターブルークラブシューズ',
            imgUrl      : '/images/items/NC-J3-34.png',
            aggregation : 'NC-J3-32',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-35',
            rare        : 'R',
            name        : 'マジカる☆スターブルークラブヘアアクセ',
            imgUrl      : '/images/items/NC-J3-35.png',
            aggregation : 'NC-J3-32',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-36',
            rare        : 'R',
            name        : 'マジカる☆スターレッドダイヤトップス',
            imgUrl      : '/images/items/NC-J3-36.png',
            numOwned    : { nico: 6 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-37',
            rare        : 'R',
            name        : 'マジカる☆スターレッドダイヤスカート',
            imgUrl      : '/images/items/NC-J3-37.png',
            aggregation : 'NC-J3-36',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-38',
            rare        : 'R',
            name        : 'マジカる☆スターレッドダイヤシューズ',
            imgUrl      : '/images/items/NC-J3-38.png',
            aggregation : 'NC-J3-36',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-39',
            rare        : 'R',
            name        : 'マジカる☆スターレッドダイヤヘアアクセ',
            imgUrl      : '/images/items/NC-J3-39.png',
            aggregation : 'NC-J3-36',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-40',
            rare        : 'R',
            name        : 'スウィングドットサックスブルートップス',
            imgUrl      : '/images/items/NC-J3-40.png',
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-41',
            rare        : 'R',
            name        : 'スウィングドットサックスブルーパンツ',
            imgUrl      : '/images/items/NC-J3-41.png',
            aggregation : 'NC-J3-40',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-42',
            rare        : 'R',
            name        : 'スウィングドットサックスブルーシューズ',
            imgUrl      : '/images/items/NC-J3-42.png',
            aggregation : 'NC-J3-40',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-43',
            rare        : 'R',
            name        : 'スウィングドットサックスブルーヘアアクセ',
            imgUrl      : '/images/items/NC-J3-43.png',
            aggregation : 'NC-J3-40',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-44',
            rare        : 'R',
            name        : 'スクール☆ガールスウィングトップス',
            imgUrl      : '/images/items/NC-J3-44.png',
            numOwned    : { nico: 6 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-45',
            rare        : 'R',
            name        : 'スクール☆ガールスウィングスカート',
            imgUrl      : '/images/items/NC-J3-45.png',
            aggregation : 'NC-J3-44',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-46',
            rare        : 'R',
            name        : 'スクール☆ガールスウィングシューズ',
            imgUrl      : '/images/items/NC-J3-46.png',
            aggregation : 'NC-J3-44',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-47',
            rare        : 'R',
            name        : 'スクール☆ガールスウィングヘアアクセ',
            imgUrl      : '/images/items/NC-J3-47.png',
            aggregation : 'NC-J3-44',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-48',
            rare        : 'R',
            name        : 'スウィングハートブルートップス',
            imgUrl      : '/images/items/NC-J3-48.png',
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-49',
            rare        : 'R',
            name        : 'スウィングハートブルースカート',
            imgUrl      : '/images/items/NC-J3-49.png',
            aggregation : 'NC-J3-48',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-50',
            rare        : 'R',
            name        : 'スウィングハートブルーシューズ',
            imgUrl      : '/images/items/NC-J3-50.png',
            aggregation : 'NC-J3-48',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-51',
            rare        : 'R',
            name        : 'スウィングハートブルーヘアアクセ',
            imgUrl      : '/images/items/NC-J3-51.png',
            aggregation : 'NC-J3-48',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-52',
            rare        : 'R',
            name        : 'スウィングハートピンクトップス',
            imgUrl      : '/images/items/NC-J3-52.png',
            numOwned    : { nico: 7 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-53',
            rare        : 'R',
            name        : 'スウィングハートピンクスカート',
            imgUrl      : '/images/items/NC-J3-53.png',
            aggregation : 'NC-J3-52',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-54',
            rare        : 'R',
            name        : 'スウィングハートピンクシューズ',
            imgUrl      : '/images/items/NC-J3-54.png',
            aggregation : 'NC-J3-52',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-55',
            rare        : 'R',
            name        : 'スウィングハートピンクヘアアクセ',
            imgUrl      : '/images/items/NC-J3-55.png',
            aggregation : 'NC-J3-52',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-56',
            rare        : 'R',
            name        : 'スウィングハートイエロートップス',
            imgUrl      : '/images/items/NC-J3-56.png',
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-57',
            rare        : 'R',
            name        : 'スウィングハートイエロースカート',
            imgUrl      : '/images/items/NC-J3-57.png',
            aggregation : 'NC-J3-56',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-58',
            rare        : 'R',
            name        : 'スウィングハートイエローシューズ',
            imgUrl      : '/images/items/NC-J3-58.png',
            aggregation : 'NC-J3-56',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J3-59',
            rare        : 'R',
            name        : 'スウィングハートイエローヘアアクセ',
            imgUrl      : '/images/items/NC-J3-59.png',
            aggregation : 'NC-J3-56',
          }),
        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsJR6 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'さらコレクション' })
      },

      itemsJR7 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'アンジュコレクション' })
      },

      itemsRR () {
        return _.where(this.itemsMaJor, { rare: 'RR' })
      },

      itemsHR () {
        return _.where(this.itemsMaJor, { rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => !this.itemsPBox.includes(item))
      },

      itemsBrandRank () {
        return _.where(this.itemsFiltered, { collection: 'ブランドランク' })
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsJewelPact () {
        return _.where(this.itemsFiltered, { collection: 'ジュエルパクト' })
      },

      itemsDesignPalette () {
        return _.where(this.itemsFiltered, { collection: 'デザインパレット自作' })
      },

      itemsArtAutumn () {
        return _.where(this.itemsFiltered, { collection: '芸術の秋チャンネル' })
      },

      itemsHalloween () {
        return _.where(this.itemsFiltered, { collection: 'ハロウィンナイトチャンネル' })
      },

      itemsPAF () {
        return _.where(this.itemsFiltered, { collection: 'プリティーオールフレンズチャンネル' })
      },

      itemsMollyPR () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定', rare: 'PR' })
      },

      itemsMollySR () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定', rare: 'SR' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2,3,4]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR6" />
    </template>
    <template #col2>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR7" />
    </template>
    <template #col3>
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR" />
    </template>
    <template #col4>
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>
    <template #col5>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="PR モーリー限定 ★★★" color="#55b272" :items="itemsMollyPR" />
      <ItemList title="SR モーリー限定 ★★" color="#55b272" :items="itemsMollySR" />
    </template>
    <template #col6>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>
    <template #col7>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>
    <template #col8>
      <ItemList title="芸術の秋チャンネル" color="#a1c0fa" :items="itemsArtAutumn" />
      <ItemList title="ハロウィンナイトチャンネル" color="#a1c0fa" :items="itemsHalloween" />
      <ItemList title="プリティーオールフレンズチャンネル" color="#a1c0fa" :items="itemsPAF" />
      <ItemList title="ジュエルパクト" color="#a1c0fa" :items="itemsJewelPact" />
      <ItemList title="デザインパレット自作" color="#a1c0fa" :items="itemsDesignPalette" />
    </template>
    <template #col9>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(20)" />
    </template>
    <template #col10>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(20)" :isOrphan="true" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" :showHR="true" />
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (RR)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (HR)
  .Page ::v-deep .Page__col:nth-child(4) .ItemList:nth-child(1) {
    .Item:nth-child(17),
    .Item:nth-child(18),
    .Item:nth-child(19),
    .Item:nth-child(20) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(5) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(6) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
    .Page ::v-deep .Page__body {
      padding-bottom: $size-unit * 20;
    }
  }
</style>
